import React from "react";

function History() {
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.jpg)', backgroundSize: 'cover', backgroundPosition: 'top' }}></div>
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div style={{ padding: '60px' }}>
              <h3 className="hheading">Temple History</h3>
              <p className="hcontent">
                നൂറ്റാണ്ടുകള്‍ക്കു മുന്‍പ് ഒരു വെളുത്തവാവിന്‍നാള്‍ രാത്രിയുടെ മൂന്നാം യാമത്തില്‍ സര്‍വ്വാഭീഷ്ടദായിനിയായ ശ്രീ ചാമുണ്ഡേശ്വരി വനനിബിഡമായ ഈ സ്ഥലത്ത് പ്രത്യക്ഷപെട്ട് സമീപത്തുള്ള കുളത്തില്‍ നീരാടിയ ശേഷം പട്ടുചേലകള്‍ പൂവണമരചില്ലുകളില്‍ തൂക്കിയിട്ട് വിശ്രമിച്ചു. ഋഷിതുല്യനായ കുടുംബകാരണവര്‍ പ്രഭാതത്തില്‍ കണ്ടത് ഹാരം പോലെ തൂക്കിയിട്ടിരിക്കുന്ന പട്ടുചേലകളും ഒരു നാരുവട്ടി നിറയെ പലവര്‍ണങ്ങളിലുള്ള കുപ്പിവളകളും ചേലകളും കുങ്കുമ ച്ചിമിഴും സിന്ധുരച്ചെപ്പും ഒരു ശൂലവും ആയിരുന്നു. അന്നു രാത്രി ബ്രഹ്മമുഹൂര്‍ത്തത്തില്‍ താപസ്യവര്യനായ അദ്ദേഹത്തിന് ദര്‍ശനം നല്‍കി തന്‍റെ ഇരിപ്പിടം എവിടെയാണെന്നും ചെയ്യേണ്ട പൂജാവിധികള്‍ എന്തൊക്കെയാണെന്നും വിവരിച്ചുകൊടുത്തു മറഞ്ഞു. നീരാടിയ കുളവും ചേലകള്‍ തൂക്കിയിട്ടിരുന്ന വൃക്ഷവും ദേവീസാക്ഷ്യം വഹിച്ചുകൊണ്ട് ഇപ്പോഴും നിലകൊള്ളുന്നു. പട്ടുചേലകള്‍ ഹാരം പോലെ ഇട്ടിരുന്നതിനാല്‍ അവിടെ പട്ടാരം എന്നറിയപ്പെടുന്നു.
              </p>
            </div>

          </div>
          <div className="col-md-4 about-frame" >
            <div className="about-right">
              <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" />
            </div>

          </div>
        </div>
        <div class="row">
          <div className="col-md-4 about-frame" >
            <div className="about-right">
              <img src="./images/slider-1.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-2.jpg" style={{ width: '100%' }} alt="About Us" />
              <img src="./images/slider-3.jpg" style={{ width: '100%' }} alt="About Us" />
            </div>
          </div>
          <div class="col-md-8">
            <div style={{ padding: '60px' }}>
              <p className="hcontent">
                സര്‍വ്വാഭീഷ്ടസിദ്ധി, വിദ്യാലാഭം, ഉദ്യോഗലബ്ധി, മംഗല്യഭാഗ്യം, സന്താനലാഭം, രോഗമുക്തി, സമ്പല്‍സമൃദ്ധി, നാനാരിഷ്ടതകളില്‍ നിന്ന് മോചനം, ആരോഗ്യം, മന:ശാന്തി, ശത്രുസംഹാരം എന്നത്യാദികള്‍ പ്രദാനം ചെയ്തുകൊണ്ട് വരദാനപ്രിയയായ പട്ടാരത്തു ചാമുണ്ഡേശ്വരി നാടിനേയും നാട്ടാരെയും സംരക്ഷിച്ചുപോരുന്നു. സര്‍പ്പശാപഗ്രസ്തരായ സ്ത്രീകള്‍ക്കും കുടുംബത്തിനും മോചനത്തിനും ഐശ്വര്യത്തിനും ഇവിടുത്തെ നാഗര്‍പൂജ പ്രസിദ്ധമാണ്. ശത്രുസംഹാരത്തിനും മറ്റ് ഈതിബാധകളില്‍ നിന്നുള്ള മോചനത്തിനും ഇവിടുത്തെ കരിംകാളി പൂജയും കോഴിനേര്‍ച്ചയും പൊങ്കാലയും പ്രസിദ്ധമാണ്. ജന്മനാളുകളിലും പക്കനാളുകളിലും ദേവീ പൂജ, പന്തിരുനാഴി. നാഗര്‍പൂജ, തുലാഭാരം, ഗണപതി ഹോമം മുതലായവ നടത്തുന്നത് വളരെ വിശിഷ്ടമാണ്.
              </p>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">
            <h3 className="hheading" style={{ textAlign: 'center' }}>മാതൃവന്ദനം</h3>
            <p className="hcontent" style={{ textAlign: 'center' }}>
              മാറാരോഗത്തിനായുള്ള <br />
              ദിവ്യഔഷധമതൊന്നുതാന്‍ <br />
              ഭക്തിയോടെ മനംനൊന്തു <br />
              കേണപേക്ഷിക്കു ദേവിയെ <br />
              ദേവിതന്നെ മഹാശക്തി <br />
              ദേവിതന്നെ മഹാധനം <br />
              സര്‍വം ദേവിയിലര്‍പ്പിച്ചു <br />
              സത്യം ചെയ്യുന്നു ഞാനിതാ (ദേവി) <br />
              എല്ലാം നിന്നിലടങ്ങുന്നു <br />
              ഗുരുവും വൈദ്യനും തഥാ <br />
              ഏകാന്തമായ ഭക്തിക്കായ്‌ <br />
              ആശ്രയിക്കുന്നു നിന്‍പാദം (ദേവി) <br />
              അമ്മതന്‍ പാദമേ രക്ഷ <br />
              അമ്മതന്‍ ദയയേ ഗതി. <br />
              സര്‍വവും ദേവിയമ്മതന്‍ (ദേവി) <br />
            </p>
            <p className="hcontent" style={{ textAlign: 'center', textDecoration: 'underline', lineHeight: '25pt', fontSize: '18pt' }}>
              ശക്തി സ്വരൂപിണിയായ <br />
              ദേവിയും മാതൃഭാവവും
            </p>

          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <div style={{ padding: '60px' }}>
              <p className="hcontent">
                പ്രപഞ്ച ചൈതന്യത്തെ ആദിപരാശക്തിയായി മാതൃഭാവത്തില്‍ ദര്‍ശിച്ച് ആരാധിച്ചു വരുന്ന സമ്പ്രദായത്തിന് വൈദികകാലത്തോളം പഴക്കമുണ്ട്. സച്ചിദാനന്ദസ്വരൂപമായ ഈ ചൈതന്യ വിശേഷമാണ് സകലചരാചരങ്ങളിലും അമൃതബിന്ദുവായ്‌ നിറയുന്നത്. മനുഷ്യനും ഇതര ജീവജാലങ്ങള്‍ക്കും ഈശ്വരന്‍ നല്‍കിയ ഏറ്റവും ഉദാത്തമായ വരമാണ് മാതൃസ്നേഹം. അത് വിശുദ്ധിയുടെ മൂര്‍ത്തിമദ്ഭാവവും വാത്സല്യത്തിന്‍റെ പൂനിലാവും സ്നേഹത്തിന്‍റെ പാല്‍ക്കടലുമാണ്.
              </p>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">

            <p className="hcontent" style={{ textAlign: 'center' }}>
              ആപദി കിം കരണീയം സ്മരണീയം <br />
              ചരണയുഗളം അംബായാ: <br />
              തതസ്മരണം കിം കുരുതേ <br />
              ബ്രഹ്മാദീനപി ച കിം കരികുരുതേ <br />
            </p>
            <p className="hcontent">
              എന്ന ആപ്തവാക്യം നല്‍കുന്ന സന്ദേശവുമിതാണ്. മാതൃസ്നേഹത്തിനു പകരംവയ്ക്കാന്‍ പ്രപഞ്ചത്തില്‍ മറ്റൊന്നില്ല. അമ്മയുടെ മടിത്തട്ടിലും ആ സ്നേഹത്തിന്‍റെ തണലിലും ഒരു കുഞ്ഞ് അനുഭവിക്കുന്ന സുരക്ഷിതത്വവും സമാധാനവും സംതൃപ്തിയും അനിര്‍വചനീയമായ അനുഭൂതിയാണ്. ജഗന്മാതാവായ ആദിപരാശക്തി സാന്നിദ്ധ്യവും ഈ പവിത്രമായ അനുഭൂതി തന്നെയാണ് പകരുന്നത്.

            </p>
          </div>
        </div>
        <div className="row" style={{ padding: '50px', background: 'orange', marginBottom: '50px', borderRadius: '25px' }}>
          <div className="container">

            <p className="hcontent" style={{ textAlign: 'center' }}>
              ശിവ:ശക്ത്യായുക്തോ യദി ഭവതി ശക്ത:പ്രഭവിതും <br />
              ന ചേദേവം ദേവോ ന ഖലു കുശല:സ്പന്ദിതുമപി <br />
              അതസ്ത്വാമാരാധ്യം ഹരിഹരവിരിഞ്ചാദിഭിരപി <br />
              പ്രണന്തും സ്തോതും വാ കഥമകൃതപുണ്യ: പ്രഭവതി <br />
            </p>
            <p className="hcontent">
              എന്ന ശങ്കരാചാര്യശ്ലോകം (സൗന്ദര്യലഹരി) അര്‍ത്ഥമാക്കുന്ന നതും മാതൃഭാവത്തിന്‍റെ മഹത്വമാണ്. ശിവന്‍ ശക്തിസ്വരൂപിണിയോടുകൂടി ചേരുമ്പോള്‍ മാത്രമേ സൃഷ്ടി സ്ഥിതി സംഹാരാദി കര്‍മ്മങ്ങള്‍ സാധ്യമാവുകയുള്ളൂ. അതുകൊണ്ട് ത്രിമൂര്‍ത്തികളും മറ്റ് ദേവന്മാരും ശക്തിസ്വരൂപിണിയായ ജഗന്മാതാവിനെ ആരാധിക്കുന്നു. അപ്രകാരം അമ്മയെ പ്രണമിക്കുകയും സ്തുതിക്കുകയും ചെയ്യാത്തിടത്ത് സിദ്ധിയും ശക്തിയും എങ്ങനെ ലഭിക്കുമെന്നാണ് ആചാര്യര്‍ വിവക്ഷിക്കുന്നത്.

            </p>
          </div>
        </div>
        <div class="row">
          <p className="hcontent">
            നിര്‍ഗ്ഗുണവും നിഷ്ക്രിയവും നിഷ്കളങ്കവുമായ ബോധസ്വരൂപമാണ് ശിവത്വമെങ്കില്‍ ആ ബോധസ്വരൂപത്തില്‍ അന്തര്‍ലീനമായിരിക്കുന്ന ക്രിയാത്മകതയാണ് ശക്തി. അത് ബ്രഹ്മത്തില്‍ നിന്ന് അഭിന്നവും ബ്രഹ്മത്തെ പ്രവര്‍ത്തിപ്പിക്കുന്നതും സ്വയം ദീപ്തവും ബ്രഹ്മാണ്ഡ കോടികളില്‍ വ്യാപ്തവുമായ ചൈതന്യമാണ് എന്നാണ് ഋഷിമതം. വാക്കും അര്‍ത്ഥവും പോലെ ഗുണവും ഗുണിയും പോലെ തീയും ചൂടും പോലെ പ്രകൃതിയും പുരുഷനും പോലെയാണ് ശിവശക്തി സംഗമം-അത് പ്രപഞ്ചത്തിന്‍റെ മൂലകാരണവും പരമസത്യവുമാണ്. <br />
            ബ്രഹ്മാണ്ഡപുരാണം, ദേവീഭാഗവതം, ദേവീപുരാണം, കാളികപുരാണം എന്നിവയില്‍ പ്രപഞ്ചസൃഷ്ടി സ്ഥിതിലയകാരിണിയായും ത്രിമൂര്‍ത്തികള്‍ക്ക് നാഥയായും ദേവിയെ പ്രകീര്‍ത്തിക്കുന്നുണ്ട്‌. കൌളോപനിഷത്ത്, ഭാവനോപനിഷത്ത്, ത്രിപുരതാവിനി ഉപനിഷത്ത് തുടങ്ങിയവയിലും ദേവ്യാരാധനയുടെ പ്രാധാന്യവും മഹത്വവും വെളിപ്പെടുത്തുന്നുണ്ട്. ശ്രീ മഹാഭാഗവാതത്തില്‍ ശ്രീകൃഷ്ണപ്രീതിക്കായി ഗോപികമാര്‍ പ്രാര്‍ത്ഥിക്കുന്നതും ആദിപരാശക്തിയെസ്തുതിച്ചുകൊണ്ടാണ്. ആദികാവ്യമായ രാമായണത്തില്‍ ജീവിതവിജയത്തിനായി ശ്രീരാമചന്ദ്രനും മഹാഭാരതത്തില്‍ ശ്രീകൃഷ്ണ നിര്‍ദ്ദേശാനുസരണം പാണ്ഡവര്‍ യുദ്ധവിജയത്തിനും ദുര്‍ഗ്ഗാദേവിയെ പ്രാര്‍ത്ഥിക്കുന്നുണ്ട്. മഹാപ്രളയാബ്ധിക്കുശേഷം മഹാവിഷ്ണു ബാലരൂപിയായി അരയാലിലയില്‍ ശയിക്കുന്ന സമയത്ത് ദുര്‍ഗ്ഗാഭഗവതി ശംഖുചക്ര ഗദാപങ്കജധാരിയായും ദിവ്യ വസ്ത്രാഭരണ വിഭൂഷിതയായും ഭഗവാന് മുന്നില്‍ ദര്‍ശനം നല്‍കിയതായി ദേവീ ഭാഗവതം പറയുന്നു. ഗീത ഉപയോഗിക്കുന്നതിനു മുന്‍പ് ശ്രീകൃഷ്ണന്‍ അര്‍ജുനനോട് ദുര്‍ഗ്ഗാദേവിയെ പൂജിക്കാന്‍ പറയുന്നുണ്ട്. <br />

            അറുപത്തിനാലു ഭിന്നഭാവങ്ങളിലായാണ് ദുര്‍ഗ്ഗാദേവി ആരാധിക്കപ്പെടുന്നത്. ശാന്തഭാവത്തിലും രൗദ്രഭാവത്തിലും ദേവിയെ പൂജിക്കുന്നു. വേദമാതാവും വേദസ്വരൂപിണിയുമായ ഗായത്രിയായും ഐശ്വര്യദേവതയായ മഹാലക്ഷ്മിയായും വിദ്യാദേവതയായ സരസ്വതിയായും നിറയുന്നത് ദേവിയുടെ സൗമ്യഭാവങ്ങളാണ്. പാര്‍വ്വതി, ഹൈമവതി, ഭവാനി, ശങ്കരി, ജഗദാംബിക, ശ്യാമ, ചാണ്ടിക, കാളി, ഭൈരവി എന്നിവയാണ് ശ്രീദുര്‍ഗ്ഗയുടെ രൗദ്രഭാവങ്ങള്‍.
          </p>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div style={{ padding: '60px' }}>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default History;
